import {put, takeLatest} from 'redux-saga/effects';
import {NAVIGATION_FETCH_CONFIG} from './constants';
import {appLoadInitValues} from '../app/actions';

export function* navigationFetchConfigSaga() {
	yield takeLatest(NAVIGATION_FETCH_CONFIG, function* () {
		yield put(appLoadInitValues());
	});
}
